import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { FormControl, Validators } from '@angular/forms';
import { ConfigService } from '../../../services/config.service';
import { DatasourceConnectionComponent } from '../../datasource-connection/datasource-connection.component';
import { Dsps } from '@rubii/share/src/constants';
import { ClientService } from '../../../services/client.service';
import { HttpException } from '@rubii/share/src/classes';

interface GamNetwork {
  id: string;
  name: string;
}

@Component({
  selector: 'app-gam',
  templateUrl: './gam.component.html',
  styleUrls: ['./gam.component.scss']
})
export class GamComponent extends BaseDatasourceComponent implements OnInit {

  gamNetworkIds: FormControl;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { dataSourceId: number, networks: GamNetwork[] }, private client: ClientService, private config: ConfigService, private snackBar: MatSnackBar, private dialogRef: MatDialogRef<DatasourceConnectionComponent>) {
    super();
  }

  ngOnInit() {
    this.gamNetworkIds = new FormControl('', [Validators.required]);

  }

  connect() {
    this.client.account.addGamNetworkIds({networkIds: this.gamNetworkIds.value})
      .then(result => {
        this.openSnackBar(this.snackBar, 'Data source connected.', 'closed'); 
        this.dialogRef.close({dataSourceId: Dsps.GAM});
      })
      .catch(e => this.openSnackBarWarning(this.snackBar, (e as HttpException).message, 'closed'));
  }
}